import { ActivitySection } from './ActivitySection';

export default ActivitySection;
